import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  seedPhraseEntryTitle: {
    id: 'SeedPhraseEntryPage.seedPhraseEntryTitle',
    defaultMessage: 'Enter your secret recovery phrase',
    description: 'Title for seed phrase entry',
  },
  seedPhraseEntryDescription: {
    id: 'SeedPhraseEntryPage.seedPhraseEntryDescription',
    defaultMessage: `When setting up your Commerce account, you were given a 12-word recovery phrase for your
        Commerce wallet. Enter your wallet's 12-word recovery phrase or private key.`,
    description: 'Description for seed phrase entry',
  },
  whereCanIFindMyRecoveryPhrase: {
    id: 'SeedPhraseEntryPage.whereCanIFindMyRecoveryPhrase',
    defaultMessage: 'Where can I find my recovery phrase?',
    description: 'Where can I find my recovery phrase?',
  },
  notSureWhereRecoveryPhraseIs: {
    id: 'SeedPhraseEntryPage.notSureWhereRecoveryPhraseIs',
    defaultMessage: `I am not sure where my recovery phrase is, what do I do now?`,
    description: 'I am not sure where my recovery phrase is, what do I do now?',
  },
  whoCanIContactToTroubleshoot: {
    id: 'SeedPhraseEntryPage.whoCanIContactToTroubleshoot',
    defaultMessage: `Who can I contact to troubleshoot?`,
    description: 'Who can I contact to troubleshoot?',
  },
  googleDriveRecoveryButton: {
    id: 'SeedPhraseEntryPage.googleDriveRecoveryButton',
    defaultMessage: 'Cloud Backup',
    description: 'button to open up a modal to recover the seed phrase from google drive backup',
  },
  recoveryPhraseTitle: {
    id: 'SeedPhraseEntryPage.recoveryPhraseTitle',
    defaultMessage: 'Get your recovery phrase',
    description: 'Title for Get your recovery phrase',
  },
  recoveryPhraseDescription: {
    id: 'SeedPhraseEntryPage.recoveryPhraseDescription',
    defaultMessage:
      'Sign in to Google Drive from the portal, copy the phrase and paste it in the text field below.',
    description: 'Description for Get your recovery phrase',
  },
});
